const GET_SHARED_RIFF = 'GET_SHARED_RIFF';
const GET_SHARED_RIFF_SUCCESS = 'GET_SHARED_RIFF_SUCCESS';
const GET_SHARED_RIFF_FAIL = 'GET_SHARED_RIFF_FAIL';

export {
  GET_SHARED_RIFF, GET_SHARED_RIFF_SUCCESS, GET_SHARED_RIFF_FAIL,
};
